import { render } from "./FixedHeaderTable.vue?vue&type=template&id=83c77aac"
import script from "./FixedHeaderTable.vue?vue&type=script&lang=ts"
export * from "./FixedHeaderTable.vue?vue&type=script&lang=ts"
script.render = render

export default script